/**
 * Button With Content Section Component is a full width component with an optional title, required content and button
 */
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '../../Button';
var defaultProps = {
  brand: 'law',
  heading: null,
  content: null,
  subContent: null,
  buttonLabel: '',
  buttonType: 'primary',
  url: '',
  anchorLink: null
};

/**
 * Button With Content React Component
 *
 * @param  {string} brand => The brand
 * @param  {node} heading => The content title, optional
 * @param  {node} content => The content text, required
 * @param  {node} subContent => Additional content text (below the button), optional
 * @param  {string} buttonLabel => The text displayed within the button
 * @param  {string} buttonType => The button variant, primary and secondary
 * @param  {string} url => The url which clicking the button will take the user
 * @param  {node} anchorLink => A gatsby anchor link if the link is to an id in contentful
 */
var ButtonWithContentSection = function ButtonWithContentSection(_ref) {
  var brand = _ref.brand,
    heading = _ref.heading,
    content = _ref.content,
    subContent = _ref.subContent,
    buttonLabel = _ref.buttonLabel,
    buttonType = _ref.buttonType,
    url = _ref.url,
    anchorLink = _ref.anchorLink;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": "button-with-content-section",
    className: "pt-5 " + brand
  }, heading && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-title",
    className: "text-center"
  }, heading)), content && /*#__PURE__*/React.createElement(Row, {
    className: "mx-0"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-text",
    className: "text-center"
  }, content)), /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-center"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 4,
    sm: 5,
    xs: 9,
    className: "my-4"
  }, anchorLink || /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement(Button, {
    brand: brand,
    label: buttonLabel,
    variant: buttonType
  })))), subContent && /*#__PURE__*/React.createElement(Row, {
    className: "mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-subcontent",
    className: "text-center"
  }, subContent)));
};
ButtonWithContentSection.defaultProps = defaultProps;
export { ButtonWithContentSection };